import { CatHeading } from "@blocks-react/components/Heading"
import { CatTextPassage } from "@blocks-react/components/TextPassage"
import { Conditional } from "../conditional"
import { FC } from "react";

export type StoreServicesOfferedProps = {
    title: string;
    serviceOffered: string[];
}

export const StoreServicesOffered: FC<StoreServicesOfferedProps> = ({
    title,
    serviceOffered = []
}) => {
    return (
        <Conditional test={!!serviceOffered.length}>
            <div className="my-3">
                <CatHeading level="h2" variant="title-sm">
                    {title}
                </CatHeading>
                <CatTextPassage size="sm">
                    {serviceOffered.join(', ')}
                </CatTextPassage>
            </div>
        </Conditional>
    )
}

